<template>
    <div class="px-3">
        <v-card-text class="pb-0">
            <v-form ref="formRef">
                <v-layout row wrap>
                    <v-flex xs12>
                        <late-info-message :overstay="1"/>

                        <v-alert
                                type="warning"
                        >
                            <b>FOR REGULATING THE OVERSTAYED VISA</b>
                        </v-alert>
                    </v-flex>
<!--                    <v-flex xs12>-->
<!--                        <v-alert-->
<!--                                outlined-->
<!--                                type="info"-->
<!--                                v-if="cost"-->

<!--                        >-->
<!--                            Your visa cost will be <strong>USD($){{cost}}</strong> with-->
<!--                            <strong>{{plan}}</strong>-->

<!--                        </v-alert>-->
<!--                    </v-flex>-->
                    <v-flex xs12 sm6>
                        <v-autocomplete
                                :items="reason_for_extension"
                                :label="$vuetify.lang.t('$vuetify.reason_for_extend') + ' *'"
                                :rules=[rules.required]
                                outlined
                                v-model="extendConvertData.purpose_of_visa"
                        />
                    </v-flex>

                    <v-flex xs12 sm6 class="pl-2">
                        <v-text-field
                                label="Mobile number in Nepal *"
                                :rules=[rules.required]
                                outlined
                                v-model="extendConvertData.mobile_number"
                        />
                    </v-flex>
                    <v-flex xs12 sm12 md4>
                        <date-picker-new
                                class="pl-3 pr-4"
                                :for-passport="true"
                                :for-processing="true"
                                v-model="extendConvertData.start_date"
                                :watch-value="true"
                                label="Visa Start Date: Day* "
                        />
                    </v-flex>

                    <v-flex xs12 sm12 md4
                            :class="{'pl-0': $vuetify.breakpoint.smAndDown, 'pl-2': $vuetify.breakpoint.mdAndUp}"
                    >
                        <v-text-field
                                :rules="[rules.required]"
                                :label="$vuetify.lang.t('$vuetify.days_staying') +' *'"
                                min="0"
                                onkeydown="return event.keyCode !== 69 && event.keyCode !== 189"
                                outlined
                                type="number"
                                v-model="extendConvertData.days_staying"
                        />
                    </v-flex>
                    <v-flex xs12 sm12 md4
                            :class="{'pl-0': $vuetify.breakpoint.smAndDown, 'pl-2': $vuetify.breakpoint.mdAndUp}">
                        <v-text-field
                                :rules="[rules.required]"
                                label="Visa Expiry Date *"
                                min="0"
                                outlined
                                type="text"
                                :disabled="true"
                                :value="expiryDate"
                        />
                    </v-flex>
                    <v-flex xs12>
                        <tourist-visa :for-processing="true"></tourist-visa>
                    </v-flex>
                </v-layout>
                <v-flex class="d-flex" xs12>
                    <v-spacer></v-spacer>
                    <v-btn
                            @click="back"
                            color="error"
                            dark
                            large
                    >{{$vuetify.lang.t('$vuetify.back')}}
                    </v-btn>
                    <v-btn
                            class=" ml-2"
                            @click="proceedConfirm"
                            large
                            color="primary">
                        {{$vuetify.lang.t('$vuetify.proceed')}}
                    </v-btn>
                </v-flex>
            </v-form>

        </v-card-text>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';

    import TouristVisa from "../components/visa/form/TouristVisa";
    import {validationMixin} from "../mixins/validationMixin";
    import LateInfoMessage from "../components/LateInfoMessage";
    import {fetchDynamicValues} from "../helpers/dynamicValueHelper";
    import moment from "moment"
    import DatePickerNew from "../components/DatePickerNew";
    import HeaderText from "../components/HeaderText";
    import Http from 'axios'
    import {API_URL, VERSION} from "../config/config";
    import {VISA_PLANS} from "../constant/appConstant";

    export default {
        name: "ExtendForm",
        components: {
            DatePickerNew,
            LateInfoMessage,
            HeaderText,
            TouristVisa
        },
        data() {
            return {
                invalid_date: false,
                show_sre: null,
                show_mre: null,
                selectedPlan: null,
                visa_plans: VISA_PLANS,
                reason_for_extension: [],
                existing_token: null
            }
        },
        mixins: [validationMixin],
        methods: {
            getConditionForDependent() {
                this.$store.dispatch('VisaType/fetchConditionForDependentExtend', this.extendConvertData.extend_visa_type)
            },
            async proceedConfirm() {
                if (this.$refs.formRef.validate()) {
                    if (this.extendConvertVisaDetail.late_days > this.extendConvertData.days_staying) {
                        this.$store.commit('Notification/showError', 'You need to apply for ' + this.extendConvertVisaDetail.late_days + ' minimum days');
                        return;
                    }


                    this.extendConvertData.plan_name = this.plan;
                    this.extendConvertData.plan = this.extendConvertData.visaPlan;
                    this.extendConvertData.documents = this.documents;
                    this.extendConvertData.cost = this.cost;
                    this.extendConvertData.overstay_processing = 1;
                    this.extendConvertData.expiry_date = this.expiryDate;


                    this.$router.push({
                        name: 'ExtendConfirm'
                    })


                }
            },

            back() {
                this.$router.go(-1);
            },
        },
        async updated() {

            const current_token = this.extendConvertVisaDetail.access_token;
            if (this.existing_token !== current_token) {
                await this.$store.dispatch('VisaType/fetchConditionsForExtend');
                if (this.extend_condition !== undefined && this.extend_condition.length === 1) {
                    this.extendConvertData.condition = this.extend_condition[0].id
                }
                this.existing_token = current_token;
            }
        },
        computed: {
            ...mapGetters('VisaType', ['conditions', 'extend_condition', 'visa_type_slug', 'old_visa']),
            ...mapGetters('VisaSingle', ['convert_visa_options', 'extendConvertVisaDetail']),
            dependent_visa_options() {
                let dependent_visa_options = this.$store.state.VisaSingle.convert_visa_options.filter(item => item.slug !== 'tourist-visa').filter(item => item.slug !== 'dependent-visa');
                const office_name = this.$store.state.VisaSingle.office.toLowerCase();
                if (office_name === 'doi') {
                    return dependent_visa_options;
                }
                const pokhara_office_options = ['relation-visa', 'nrn-visa', 'marriage-visa']
                return dependent_visa_options.filter((i) => pokhara_office_options.indexOf(i.slug) > -1);
            },
            extendConvertData() {
                return this.$store.state.VisaSingle.extendConvertData;
            },
            expiryDate() {
                return moment(this.extendConvertData.start_date).add(this.extendConvertData.days_staying, 'days').subtract(1, 'days').format('YYYY-MM-DD');
            },
            offices() {
                return this.$store.state.Office.offices;
            },
            showAppointment() {
                const selected_office = this.offices.find(i => i.slug === this.$store.state.VisaSingle.office)
                return selected_office.token_system_active;
            },
            condition_label() {
                let dependent_visa = this.extendConvertVisaDetail.dependent_visa ? "Dependent visa" : this.extendConvertVisaDetail.visa_type;

                return "Available condition for " + dependent_visa + " *"
            },
            documents() {
                if (this.extendConvertData.condition) {
                    let selected_condition = this.extend_condition.find((i) => i.id === this.extendConvertData.condition);

                    if (selected_condition)
                        return selected_condition.documents;
                }
                return [];
            },
            plan() {
                if (this.extendConvertData.apply_extend_gratis)
                    return "Multiple Re-entry";

                if (!this.extendConvertData)
                    return false;

                if (!this.extendConvertData.visaPlan)
                    return false;

                return this.visa_plans.find((i) => i.key === parseInt(this.extendConvertData.visaPlan)).value;
            },
            cost() {

                return this.extendConvertData.days_staying * 3;


            },
            message() {
                const selected_condition = this.conditions.find((c) => c.id === this.extendConvertData.condition);
                if (selected_condition) {
                    return selected_condition.extension_message;
                } else {
                    return false;
                }
            }
        },
        async mounted() {
            this.extendConvertData.start_date = moment(this.extendConvertVisaDetail.expiry_date).add(1, 'days').format('YYYY-MM-DD');

            fetchDynamicValues('ReasonForExtension').then((data) => {
                this.reason_for_extension = data;
            });
            const default_selected_visa_type = this.dependent_visa_options.find(item => item.slug === this.extendConvertVisaDetail.slug);
            if (default_selected_visa_type !== undefined)
                this.extendConvertData.extend_visa_type = default_selected_visa_type.id
        }

    }
</script>
